import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { filter, Observable, Subject, take, takeUntil } from 'rxjs';
import { CanComponentDeactivate } from 'src/app/core/guard/unsaved-changes.guard';
import { ErrorhanderService } from 'src/app/core/services/error-handler.service';
import { LMSDialogHandlerService } from 'src/app/shared/lmsdialog-handler.service';
import {
  MdbFormsModule, MdbOptionModule, MdbPopoverDirective, MdbPopoverModule, MdbRadioModule, MdbSelectModule,
} from 'src/lib/mdb5-adapted/public-api';

import {
  ClientSearchModel, ClientShowModel, ClientType, LMSReasonCodesModel, PaySlipModel1, PreAuthorisationModel,
} from '@lmsModels';
import { ClientDetailsService, QuoteStoreService } from '@lmsrestServices';
import { NumbersOnlyDirective } from '@lmsSharedUI';

import { AppUtilityService } from '../app-utility.service';
import { LMSConstantsService } from '../core/constants';
import { LMSPageHeadComponent } from '../core/guard/LMSPageHeader.guard';
import { QuoteChangedService } from '../core/services/changed-service.service';
import { LoanReasonCodesService } from '../modules/loan-reason-codes/loan-reason-codes.service';
import {
  MarketingOptionsParametersService,
} from '../modules/marketing-options-parameters/marketing-options-parameters.service';
import { SalariedEditorComponent } from './salaried-editor/salaried-editor.component';
import { SassaEditorComponent } from './sassa-editor/sassa-editor.component';

const SALARIEDTYPEDESC = 'Salaried';
const SASSATYPEDESC = 'SASSA';
const PENSIONERTYPEDESC = 'Pensioner';

@Component({
  selector: 'app-client-search',
  templateUrl: './client-search.component.html',
  styleUrls: ['./client-search.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdbFormsModule,
    MdbRadioModule,
    SassaEditorComponent,
    SalariedEditorComponent,
    NumbersOnlyDirective,
    MdbPopoverModule,
    MdbSelectModule,
    MdbOptionModule,
  ],
})
export class ClientSearchComponent
  implements OnInit, AfterViewInit, OnDestroy, CanComponentDeactivate, LMSPageHeadComponent
{
  public lmsPageHead: () => 'Client Information';

  private readonly grossIncomeCaps: Record<string, number> = {
    weekly: 15000,
    fortnightly: 25000,
    monthly: 230000,
  };

  private quoteWorkbookInputProvided = false;
  private _quoteWorkbook$: Observable<any> = this.quoteStoreService.quoteData2$;

  @Input()
  set quoteWorkbook(value: Observable<any> | null | undefined | false) {
    this.quoteWorkbookInputProvided = !!value;
    this._quoteWorkbook$ = value || this.quoteStoreService.quoteData2$;
  }

  get quoteWorkbook(): Observable<any> {
    return this._quoteWorkbook$;
  }

  @ViewChild(MdbPopoverDirective) popover!: MdbPopoverDirective;

  clientSearchModel = {} as ClientSearchModel;
  preAuthorisationModel = {} as PreAuthorisationModel;
  private _originalPreAuthVal: any;

  compuscanOffers: any;
  submitted = false;
  clientShowModel = {} as ClientShowModel;
  lstAllLoanReasonCodes: LMSReasonCodesModel[] = [];

  lstMarketingOptions: any[] = [];
  isContractType: boolean;
  isPermEmployedType: boolean;
  isRejectOfferRejected: boolean;
  isMONoneSelected = false;
  isMAOtherOptionSelected = false;
  isCPNoneSelected = false;
  ClientTypeSASSA = false;
  originalClientType: string;
  originalEmployer: string;
  compuscanOffersEvery = false;
  quoteFormLoading = false;
  rejectionLetterResponse: any;
  showSassaPopover = false;
  sassaEmploymentInfo: any = null;
  showBackdrop = false;
  lstSOD = this.lmsConstantService.getLMSConstant('SOURCEOFWEALTH');
  lstContactPref = this.lmsConstantService.getLMSConstant('CONTACTPREFERENCES');
  lstClientTypes = this.lmsConstantService.getLMSConstant('CLIENTTYPES');
  lstMarStatus = this.lmsConstantService.getLMSConstant('MARITALSTATUS');
  lstNAtional = this.lmsConstantService.getLMSConstant('NATIONALITY');

  private destroy$ = new Subject<void>();

  private sassaPopoverAction$ = new Subject<boolean>();
  searchForm = this.fb.group({
    clientType: [''],
    nationality: ['', []],
    loanReason: ['', [Validators.required]],
    loanAmount: [null as number | null, [Validators.required]],
    maritalStatus: ['', [Validators.required]],
    contactPreference: ['', Validators.required],
    underDebtReview: ['', [Validators.required]],
    placedUnderDebtReview: ['no', []],
    underSequestration: ['', [Validators.required]],
    underAdministration: ['', [Validators.required]],
    placedUnderAdministration: ['no', []],

    sourceOfWealth: ['', [Validators.required]],
    sourceOfWealthOther: ['', []],
    marketingOptions: new FormControl([], Validators.required),
    marketingOptionsOther: ['', []],
  });

  constructor(
    private route: ActivatedRoute,
    public quoteStoreService: QuoteStoreService,
    private fb: FormBuilder,
    public clientSearch: ClientDetailsService,
    private loanReasonCodesService: LoanReasonCodesService,
    private errorhanderService: ErrorhanderService,
    private changesService: QuoteChangedService,
    private marketingOptionsParametersService: MarketingOptionsParametersService,
    public global_utility: AppUtilityService,
    public lmsDialogHandler: LMSDialogHandlerService,
    private lmsConstantService: LMSConstantsService,
  ) {
    this.loanReasonCodesService.getAllLoanReasonCodes().subscribe({
      next: (obj: any) => {
        this.lstAllLoanReasonCodes = obj;
      },
    });

    this.marketingOptionsParametersService.findAll().subscribe((result: any) => {
      this.lstMarketingOptions = result;
      console.log('marketing list ----', this.lstMarketingOptions);
    });
  }
  ngOnDestroy(): void {
    this._originalPreAuthVal = undefined;
    this.destroy$.next();
    this.destroy$.complete();
  }
  get loanReason() {
    return this.searchForm.get('loanReason');
  }
  get loanAmount() {
    return this.searchForm.get('loanAmount');
  }
  get clientType() {
    return this.searchForm.get('clientType');
  }

  get maritalStatus() {
    return this.searchForm.get('maritalStatus');
  }
  get contactPreference() {
    return this.searchForm.get('contactPreference');
  }

  get marketingOptions() {
    return this.searchForm.get('marketingOptions') as FormControl;
  }
  get nationality() {
    return this.searchForm.get('nationality');
  }

  get underAdministration() {
    return this.searchForm.get('underAdministration');
  }

  get underSequestration() {
    return this.searchForm.get('underSequestration');
  }

  get underDebtReview() {
    return this.searchForm.get('underDebtReview');
  }
  get sourceOfWealth() {
    return this.searchForm.get('sourceOfWealth');
  }

  get isOtherNationality() {
    return this.preAuthorisationModel.nationality == 'OTHER';
  }

  closeSassaPopover(accepted: boolean): boolean {
    this.showSassaPopover = false;
    this.showBackdrop = false;
    if (this.popover) {
      this.popover.hide();
    }

    // Emit the user's decision
    this.sassaPopoverAction$.next(accepted);

    return accepted;
  }

  private getCurrentEmployerName(): string {
    const model = this.preAuthorisationModel as any;
    const resolved = [
      model?.employerName,
      model?.employer,
      model?.employment?.employerName,
      model?.employment?.name,
      model?.employment?.employer,
    ].find((value) => `${value ?? ''}`.trim().length > 0);

    return `${resolved ?? ''}`.trim();
  }

  private getCurrentEmploymentType(): string {
    const model = this.preAuthorisationModel as any;
    return `${model?.employmentType ?? model?.employment?.employmentType ?? ''}`.trim();
  }

  private buildSassaEmploymentInfo(type: ClientType): any {
    const model = this.preAuthorisationModel as any;

    return {
      employerName: this.getCurrentEmployerName(),
      employmentType: this.getCurrentEmploymentType(),
      payDate: model?.payDate ?? model?.employment?.payDate,
      wageCalendar:
        model?.wageCalendar ?? model?.employment?.wageCalendar ?? model?.employment?.wageFrequency,
      occupation: model?.occupation ?? model?.employment?.occupation,
      selectedadditionalIncome: model?.selectedadditionalIncome,
      newClientType: type,
    };
  }

  /**
   * Toggle the client's type in the pre-authorisation model while enforcing consistency
   * rules between client type and employment details.
   *
   * This method examines the requested client type and the current employment data
   * (employmentType and employerName) on this.preAuthorisationModel and performs
   * validations and side-effect updates to keep the model consistent. It also emits
   * user-visible warnings or errors via this.global_utility when user confirmation or
   * corrective action is required.
   * @param type - The target client type to toggle to (case-insensitive string representation is used).
   * @returns void
   */

  async toggleClientTypeEditor(type: ClientType): Promise<boolean> {
    const newClientType = (type || '').toString().toLowerCase();
    const currentEmploymentType = this.getCurrentEmploymentType();
    const currentEmployerName = this.getCurrentEmployerName().toLowerCase();

    // Scenario 1: Switching TO SASSA client type
    if (newClientType === 'sassa' && currentEmploymentType !== SASSATYPEDESC) {
      // Store SASSA employment information for popover display
      this.sassaEmploymentInfo = this.buildSassaEmploymentInfo(type);

      if (!this.showSassaPopover) {
        // Show popover programmatically with backdrop
        this.showSassaPopover = true;
        this.showBackdrop = true;
        setTimeout(() => {
          if (this.popover) {
            this.popover.show();
          }
        });

        // Wait for user action on the popover and return the result
        return new Promise((resolve) => {
          this.sassaPopoverAction$
            .pipe(filter((action) => action !== undefined))
            .subscribe((accepted) => {
              resolve(accepted);
            });
        });
      }
    }

    // Scenario 2: Switching FROM SASSA to non-SASSA (Salaried/Pensioner)
    if (
      newClientType !== 'sassa' &&
      currentEmploymentType === SASSATYPEDESC &&
      (currentEmployerName === 'sassa' || currentEmployerName === '')
    ) {
      // this.global_utility.warning(
      //   `Changing from SASSA to ${type} client type will clear SASSA employment information. <br/><br/> You will need to reject this application and select the correct [Employment] client type`,
      //   'Client type invalid'
      // );
      this.sassaEmploymentInfo = this.buildSassaEmploymentInfo(type);
      // Show popover programmatically with backdrop
      if (!this.showSassaPopover) {
        this.showSassaPopover = true;
        this.showBackdrop = true;
        setTimeout(() => {
          if (this.popover) {
            this.popover.show();
          }
        }, 0);

        // Wait for user action on the popover and return the result
        return new Promise((resolve) => {
          this.sassaPopoverAction$
            .pipe(filter((action) => action !== undefined))
            .subscribe((accepted) => {
              resolve(accepted);
            });
        });
      }

      // Do not apply change here; setFormCtrlChanges will handle employment specifics.
      return false;
    }

    // Scenario 3: Invalid state - non-SASSA client with SASSA employment type
    const normalizedEmployerName = currentEmployerName;
    if (currentEmploymentType === SASSATYPEDESC && normalizedEmployerName !== 'sassa') {
      if (!this.showSassaPopover) {
        // Request user confirmation to correct the inconsistency
        this.sassaEmploymentInfo = this.buildSassaEmploymentInfo(type);

        // Show popover programmatically with backdrop
        this.showSassaPopover = true;
        this.showBackdrop = true;
        setTimeout(() => {
          if (this.popover) {
            this.popover.show();
          }
        }, 0);

        // Wait for user action on the popover and return the result
        return new Promise((resolve) => {
          this.sassaPopoverAction$
            .pipe(filter((action) => action !== undefined))
            .subscribe((accepted) => {
              resolve(accepted);
            });
        });
      }
    }

    // Scenario 4: Normal case - switching between Salaried/Pensioner (safe to change)
    if (newClientType !== 'sassa' && currentEmploymentType !== SASSATYPEDESC) {
      this.preAuthorisationModel.clientType = type;

      return true;
    }

    // Scenario 5: Fallback - consider change handled (no-op) but return true to indicate resolution
    return true;
  }

  ngOnInit() {
    this.quoteFormLoading = true;

    this.getNewLMS()
      .then((isLoaded) => {
        const hasLoadedQuote = this.hasLoadedQuoteValue(this._originalPreAuthVal);

        if (!isLoaded || !hasLoadedQuote) {
          this.global_utility.stopLoading();
          this.goBack();
          return;
        }

        if (isLoaded && hasLoadedQuote) {
          this.DTOtoPreAuthorisation();
          this.PreAuthtoSearchDataForm();
        }

        this.global_utility.stopLoading();

        this.changesService.setTrackEnter(false);
        this.quoteFormLoading = false;
      })
      .catch((reason) => {
        this.global_utility.error(reason, 'Quote loading error');
        this.goBack();
      });
  }

  private hasLoadedQuoteValue(value: any): boolean {
    return !!value && Object.keys(value).length > 0;
  }

  ngAfterViewInit(): void {
    // this.PreAuthtoSearchDataForm();
  }

  getNewLMS() {
    let qid = Number(this.route.snapshot.paramMap.get('idNumber'));
    this.global_utility.startLoading('Resuming application..');
    return new Promise<boolean>((resolve, reject) => {
      // If an Id is not provided then this application is from PreAuth screen
      if (!qid || qid == 0) {
        this.global_utility.stopLoading();
        if (
          !this.quoteStoreService.isQuoteFound &&
          Object.keys(this.quoteStoreService.PreAuthorisationModel).length == 0
        ) {
          reject(new Error('Empty Workbook and no id to load, please confirm request'));
          resolve(false);
          return;
        }

        if (
          this.quoteStoreService.PreAuthorisationModel.id == 0 ||
          !this.quoteStoreService.PreAuthorisationModel.id
        ) {
          reject(new Error('Invalid Quote Id, please confirm request'));
          resolve(false);
          return;
        }

        if (this.hasLoadedQuoteValue(this.quoteStoreService.PreAuthorisationModel)) {
          qid = this.quoteStoreService.PreAuthorisationModel.id;
          //this.quoteWorkbookInputProvided = false;
          //this.quoteStoreService.setQuoteWorkbook(this.quoteStoreService.PreAuthorisationModel);
          //this.quoteWorkbook = this.quoteStoreService.quoteData2$;
        }

        const quoteSource$ = this.quoteWorkbookInputProvided
          ? this.quoteWorkbook
          : this.quoteStoreService.LoadedQuoteid(qid);

        quoteSource$
          .pipe(
            filter((currentQuote: any) => currentQuote && currentQuote.id === qid),
            take(1),
            takeUntil(this.destroy$),
          )
          .subscribe({
            next: (currentQuote) => {
              this._originalPreAuthVal = currentQuote;
              resolve(true);
              return;
            },
          });

        return;
      }

      // Make sure the latest quote details is loaded from backend
      const quoteSource$ = this.quoteWorkbookInputProvided
        ? this.quoteWorkbook
        : this.quoteStoreService.LoadedQuoteid(qid);

      quoteSource$
        .pipe(
          filter((quote: any) => quote != null && quote.id === qid),
          take(1),
        )
        .subscribe({
          next: (qofferResult: any) => {
            this._originalPreAuthVal = qofferResult;
            //this.quoteStoreService.setQuoteWorkbook(qofferResult);
            this.global_utility.stopLoading();
            resolve(true);
          },
          error: (err) => {
            this.global_utility.stopLoading();
            resolve(true);
          },
        });
    });
  }

  private DTOtoPreAuthorisation() {
    this.clientShowModel = {
      fullNames: this._originalPreAuthVal.fullNames || this._originalPreAuthVal.firstName,
      surname: this._originalPreAuthVal.surname || this._originalPreAuthVal.lastName,
      idNumber: this._originalPreAuthVal.idNumber,
      cellNumber: this._originalPreAuthVal.cellNumber,
      clientType: this._originalPreAuthVal.clientType,
      clientStatus: this._originalPreAuthVal.clientStatus,
      loanStatus: this._originalPreAuthVal.loanStatus,
      clientNumber: '',
      id: this._originalPreAuthVal.id,
    };

    this.preAuthorisationModel = this._originalPreAuthVal;
    this.preAuthorisationModel.quoteId = this._originalPreAuthVal.id;
    this.preAuthorisationModel.clientType = this._originalPreAuthVal.clientType || SALARIEDTYPEDESC;
    this.ClientTypeSASSA = this.preAuthorisationModel.clientType == SASSATYPEDESC || false;
    this.originalClientType = this.preAuthorisationModel.clientType;
    this.originalEmployer = this.preAuthorisationModel.employer;

    this._originalPreAuthVal.additionalIncome = !this._originalPreAuthVal.additionalIncome
      ? null
      : this._originalPreAuthVal.additionalIncome.length == 0
        ? null
        : this._originalPreAuthVal.additionalIncome;
    this._originalPreAuthVal.marketingOptions = !this._originalPreAuthVal.marketingOptions
      ? null
      : this._originalPreAuthVal.marketingOptions.length == 0
        ? null
        : this._originalPreAuthVal.marketingOptions;

    this._originalPreAuthVal.contactPreference = !this._originalPreAuthVal.contactPreference
      ? null
      : this._originalPreAuthVal.contactPreference.length == 0
        ? null
        : this._originalPreAuthVal.contactPreference;

    const addinfo = this.fromAttribute(
      (this._originalPreAuthVal.additionalIncome as string[]) || '',
    );
    const marketopt = this.fromAttribute(
      (this._originalPreAuthVal.marketingOptions as string[]) || '',
    );
    const conopt = this.fromAttribute(
      (this._originalPreAuthVal.contactPreference as string[]) || '',
    );
    this.preAuthorisationModel.contactPreference = conopt?.[0] || '';
    this.preAuthorisationModel.selectedadditionalIncome = addinfo?.join() || '';
    this.preAuthorisationModel.selectedMarketingOptions = marketopt?.join() || '';

    if (this._originalPreAuthVal && this._originalPreAuthVal.compuscanOffers) {
      this.compuscanOffersEvery =
        Array.isArray(this._originalPreAuthVal.compuscanOffers) &&
        this._originalPreAuthVal.compuscanOffers.length > 0 &&
        (Array.from(this._originalPreAuthVal.compuscanOffers).every(
          (compOffer: any) => compOffer.outcome == 'N',
        ) ||
          false);
    }
  }

  updateMarketingOptions(value: any) {
    let selectedOptions = this.normalizeMultiSelectValues(value);

    const hasNone = selectedOptions.some(
      (option: string) => (option || '').toLowerCase() === 'none',
    );
    const hasOther = selectedOptions.some(
      (option: string) => (option || '').toLowerCase() === 'other',
    );

    // NONE and OTHER are mutually exclusive and each should clear all other choices.
    if (hasNone && selectedOptions.length > 1) {
      selectedOptions = ['None'];
      this.marketingOptions?.setValue(selectedOptions, { emitEvent: false });
    } else if (hasOther && selectedOptions.length > 1) {
      selectedOptions = ['Other'];
      this.marketingOptions?.setValue(selectedOptions, { emitEvent: false });
    }

    this.preAuthorisationModel.marketingOptions = selectedOptions;
    this.isMONoneSelected = selectedOptions.some(
      (option: string) => (option || '').toLowerCase() === 'none',
    );
    this.isMAOtherOptionSelected = selectedOptions.some(
      (option: string) => (option || '').toLowerCase() === 'other',
    );
  }

  updatecontactPreference(value: any) {
    const selectedOptions = this.normalizeMultiSelectValues(value);
    const selectedOption = selectedOptions[0] || '';

    if (selectedOptions.length > 1 || Array.isArray(value) || Array.isArray(value?.value)) {
      this.contactPreference?.setValue(selectedOption as any, { emitEvent: false });
    }


    this.preAuthorisationModel.contactPreference = selectedOption;
    // this.isCPNoneSelected = selectedOptions.some(
    //   (option: string) => (option || '').toLowerCase() === 'none'
    // );
  }

  private normalizeMultiSelectValues(value: any): string[] {
    const rawValues = Array.isArray(value)
      ? value
      : Array.isArray(value?.value)
        ? value.value
        : value?.value != null
          ? [value.value]
          : value != null
            ? [value]
            : [];

    return rawValues
      .map((option: any) => {
        if (option == null) {
          return '';
        }

        if (
          typeof option === 'string' ||
          typeof option === 'number' ||
          typeof option === 'boolean'
        ) {
          return `${option}`.trim();
        }

        const extracted = option.value ?? option.description ?? option.label ?? '';
        return `${extracted}`.trim();
      })
      .filter((option: string) => option.length > 0);
  }

  private PreAuthtoSearchDataForm() {
    if (!this._originalPreAuthVal) {
      return;
    }

    const asMultiSelectArray = (value: any): string[] => {
      const normalized: any = this.fromAttribute(value || '');
      if (Array.isArray(normalized)) {
        return normalized
          .map((item: any) => `${item ?? ''}`.trim())
          .filter((item: string) => item.length > 0);
      }

      const singleValue = `${normalized ?? ''}`.trim();
      if (singleValue.length > 0) {
        return [singleValue];
      }

      return [];
    };

    this.searchForm.patchValue(
      {
        clientType: this._originalPreAuthVal.clientType ?? '',
        nationality: this._originalPreAuthVal.nationality ?? '',
        loanReason: this._originalPreAuthVal.loanReason ?? '',
        loanAmount: this._originalPreAuthVal.loanAmount ?? null,
        maritalStatus: this._originalPreAuthVal.maritalStatus ?? '',
        underDebtReview: this._originalPreAuthVal.underDebtReview ?? '',
        underSequestration: this._originalPreAuthVal.underSequestration ?? '',
        underAdministration: this._originalPreAuthVal.underAdministration ?? '',
        sourceOfWealth: this._originalPreAuthVal.sourceOfWealth ?? '',
        sourceOfWealthOther: this._originalPreAuthVal.sourceOfWealthOther ?? '',
      },
      { onlySelf: false, emitEvent: true },
    );

    const cpopts = asMultiSelectArray(this._originalPreAuthVal.contactPreference);
    const selectedContactPreference = cpopts[0] || '';
    this.contactPreference?.setValue(selectedContactPreference as any, {
      onlySelf: true,
      emitEvent: false,
    });
    this.updatecontactPreference(selectedContactPreference);

    const maopts = asMultiSelectArray(this._originalPreAuthVal.marketingOptions);
    this.marketingOptions.setValue(maopts, { onlySelf: true, emitEvent: false });
    this.updateMarketingOptions(maopts);

    if (this._originalPreAuthVal && this._originalPreAuthVal.id! > 0) {
      this.setFormCtrlChanges();
      this.searchForm.controls.clientType.patchValue(this._originalPreAuthVal.clientType ?? '', {
        emitEvent: true,
      });
      this.searchForm.controls.clientType.updateValueAndValidity({
        onlySelf: true,
        emitEvent: true,
      });
    }

    this.valuesDialog();
    console.info('path ancestorOrigins >> ', location.ancestorOrigins);
  }

  valuesDialog() {
    this.lmsDialogHandler.openCompuscanOffersDialog(
      this._originalPreAuthVal.compuscanOffers,
      false,
    );
  }

  public canDeactivate(): Promise<boolean> {
    return Promise.resolve(this.changesService.NavigationAllowed);
  }

  fromAttribute(newVal) {
    return !newVal
      ? null
      : (newVal as string).length == 0
        ? null
        : (newVal as string).split(',').map((x) => x.trim());
  }

  private setFormCtrlChanges() {
    this.clientType?.valueChanges.subscribe((clientType) => {
      this.submitted = false;

      void this.toggleClientTypeEditor(clientType as ClientType)
        .then((isChanged) => {
          this._originalPreAuthVal.doUpdateEmployment = false;
          if (this._originalPreAuthVal.clientType != clientType) {
            this._originalPreAuthVal.doUpdateEmployment = isChanged;
          }

          if (!isChanged) {
            this.searchForm.controls.clientType.patchValue(this.preAuthorisationModel.clientType, {
              emitEvent: false,
            });
            this.refreshClientTypeValidation();
            return;
          }

          if (clientType === SASSATYPEDESC) {
            this.ClientTypeSASSA = true;
            this.preAuthorisationModel.clientType = SASSATYPEDESC;
            this.preAuthorisationModel.employer = SASSATYPEDESC;
            this.preAuthorisationModel.employerName = SASSATYPEDESC;
            this.preAuthorisationModel.employerTNR = 0;
            this.preAuthorisationModel.employmentType = 'SASSA';
            this.preAuthorisationModel.payDate = '4';
            this.preAuthorisationModel.wageCalendar = 'Monthly';

            this.preAuthorisationModel.industryType = '';
            this.preAuthorisationModel.industryTypeOther = '';
            // Information should be set by popover closeSassaPopover if accepted
          } else {
            this.preAuthorisationModel.clientType =
              clientType?.toLowerCase() == SALARIEDTYPEDESC.toLowerCase()
                ? SALARIEDTYPEDESC
                : PENSIONERTYPEDESC;
            this.ClientTypeSASSA = false;

            // Use originalEmployer (captured at initialization) to determine if we should restore employer info
            // This accounts for the case where user switched TO SASSA and then switches back
            if (this.originalEmployer && this.originalEmployer.toLowerCase() !== 'sassa') {
              // Restore original employer information
              this.preAuthorisationModel.employer = this.originalEmployer;
              this.preAuthorisationModel.employerName = this.originalEmployer;
              this.preAuthorisationModel.employerTNR = Number(
                this._originalPreAuthVal?.employment?.employerTNR ??
                  this._originalPreAuthVal?.employerTNR ??
                  0,
              );
            } else {
              // Original was SASSA or empty, clear employer fields
              this.preAuthorisationModel.employer = '';
              this.preAuthorisationModel.employerName = '';
              this.preAuthorisationModel.employerTNR = 0;
            }
            // Reset employment type to Permanent (contract dates should not be shown)
            this.preAuthorisationModel.employmentType = 'Permanent';
            this.preAuthorisationModel.payDate =
              this._originalPreAuthVal.employment && this._originalPreAuthVal.employment.payDate > 0
                ? this._originalPreAuthVal.employment?.payDate
                : '4';
          }

          this.refreshClientTypeValidation();
        })
        .catch(() => {
          this.searchForm.controls.clientType.patchValue(this.preAuthorisationModel.clientType, {
            emitEvent: false,
          });
          this.refreshClientTypeValidation();
        });
    });

    this.sourceOfWealth?.valueChanges.subscribe((value) => {
      if (this.quoteFormLoading) {
        return;
      }
      if (value && value == 'Other') {
        this.searchForm.get('sourceOfWealthOther')?.enable();
        this.searchForm.get('sourceOfWealthOther')?.addValidators(Validators.required);
        this.searchForm.get('sourceOfWealthOther')?.updateValueAndValidity();
      } else {
        this.searchForm.get('sourceOfWealthOther')?.disable();
        if (this.searchForm.get('sourceOfWealthOther')?.hasValidator(Validators.required)) {
          this.searchForm.get('sourceOfWealthOther')?.removeValidators(Validators.required);
        }
      }
    });

    this.marketingOptions?.valueChanges.subscribe((value) => {
      this.updateMarketingOptions(value);
    });

    this.contactPreference?.valueChanges.subscribe((value) => {
      this.updatecontactPreference(value);
    });
  }

  submitClientSearch() {
    setTimeout(() => {
      this.submitted = true;
      const controlKey = this.ClientTypeSASSA ? 'sassaTypeControls' : 'salariedTypeControls';
      if (!this.ensureActiveClientTypeGroupReady(controlKey)) {
        this.submitted = false;
        return;
      }

      this.searchForm.controls[controlKey].updateValueAndValidity();
      this.searchForm.updateValueAndValidity();

      if (this.searchForm.invalid) {
        this.global_utility.findInvalidControls(this.searchForm);
        if (controlKey == 'salariedTypeControls') {
          this.global_utility.findInvalidControls(
            this.searchForm.controls[controlKey] as FormGroup,
          );
        }
        return;
      }

      console.log('Marketing Options -----', this.preAuthorisationModel.marketingOptions);

      const ControlKeyVals = { ...this.searchForm.controls[controlKey].value };

      // Normalize additional income: combine "Other" with text input
      if (
        Array.isArray(ControlKeyVals.additionalIncome) &&
        ControlKeyVals.additionalIncome.length > 0
      ) {
        const additionalIncomeOther = (ControlKeyVals.additionalIncomeOther || '').trim();
        const hasOther = ControlKeyVals.additionalIncome.some(
          (v: any) => `${v ?? ''}`.trim().toLowerCase() === 'other',
        );

        if (hasOther && additionalIncomeOther) {
          // Combine "Other" with the text input as "Other: [value]"
          ControlKeyVals.additionalIncome = ControlKeyVals.additionalIncome.map((v: any) => {
            const valStr = `${v ?? ''}`.trim();
            if (valStr.toLowerCase() === 'other') {
              return `Other: ${additionalIncomeOther}`;
            }
            return valStr;
          });
        }
      }

      // We dont need to add the [SASSA] or [SALARIED] FormGroup to preAuth model, so we remove it
      this.searchForm.get(controlKey)?.disable();

      // SASSA does not have additional income so we will default this until business rules are defined.
      if (this.ClientTypeSASSA) {
        ControlKeyVals.additionalIncome = ['None'];
        this.preAuthorisationModel.selectedadditionalIncome = 'None';
        this.preAuthorisationModel.employmentType = 'SASSA';
        this.preAuthorisationModel.occupation = ControlKeyVals.grantType;
      } else {
        if (!ControlKeyVals.employerTNR || ControlKeyVals.employerTNR == 0) {
          this.global_utility.warning(
            'The employer does not exist! Create the employer on `Branch Admin | Maintain Employers` menu above.',
            'Employer requirement missing',
          );
          this.submitted = false;
          this.searchForm.get(controlKey)?.enable();
          return;
        }
        // This is duplicate code because of the undefined rules of switching between salaried and sassa client types
        // this is required to fix the .join exception when SASSA
        const additionalIncomeValue = `${ControlKeyVals.additionalIncome ?? ''}`.trim();
        this.preAuthorisationModel.selectedadditionalIncome = additionalIncomeValue || '';
      }

      this.preAuthorisationModel.selectedMarketingOptions =
        this.marketingOptions.value && Array.from(this.marketingOptions.value).length > 0
          ? Array.from(this.marketingOptions.value).join(',') ?? this.marketingOptions.value
          : '';

      const contPref = this.normalizeMultiSelectValues(this.contactPreference?.value)[0] || '';

      // Store the payslips before overwriting
      const savedPayslips = this.preAuthorisationModel.payslips;

      //Possiibly combine Fortnightly and Weekly into 3 monthly averages to remain with only 3 payslips

      // Create the new object
      this.preAuthorisationModel = {
        ...this.preAuthorisationModel,
        ...this.searchForm.value,
        ...ControlKeyVals,
      };

      // Restore the payslips if they exist
      if (savedPayslips && savedPayslips.length > 0) {
        this.preAuthorisationModel.payslips = savedPayslips;
        console.log('Restored payslips after object spread:', savedPayslips.length);
      }
      (this.preAuthorisationModel as any).capital = this.preAuthorisationModel.loanAmount || 0;

      // Do this after the object coppy above. That creates an array and breaks the backend call
      this.preAuthorisationModel.contactPreference = contPref;

      if (this.originalEmployer && this.originalEmployer != this.preAuthorisationModel.employer) {
        this.preAuthorisationModel.doUpdateEmployment = true;
      }

      if (this.originalClientType == this.preAuthorisationModel.clientType) {
        this.preAuthorisationModel.doUpdateEmployment = false;
      }

      // FIXED VALIDATION
      let hasValidIncome = false;
      const selectedFrequency = this.getSelectedIncomeFrequency().toLowerCase();
      const uiPayslips = Array.isArray(this.preAuthorisationModel.payslips)
        ? this.preAuthorisationModel.payslips.filter((p: any) => !!p)
        : [];

      if (selectedFrequency === 'weekly') {
        const weeklyPayslips = uiPayslips.filter((p: any) => p.week !== undefined);
        hasValidIncome =
          weeklyPayslips.length === 12 &&
          weeklyPayslips.every((p: any) => (+p.nettIncome || 0) > 0);
      } else if (selectedFrequency === 'fortnightly') {
        const fortnightlyPayslips = uiPayslips.filter((p: any) => p.fortnight !== undefined);
        hasValidIncome =
          fortnightlyPayslips.length === 6 &&
          fortnightlyPayslips.every((p: any) => (+p.nettIncome || 0) > 0);
      } else {
        hasValidIncome =
          (this.preAuthorisationModel.payslip1?.nettIncome || 0) > 0 &&
          (this.preAuthorisationModel.payslip2?.nettIncome || 0) > 0 &&
          (this.preAuthorisationModel.payslip3?.nettIncome || 0) > 0;
      }

      const incomeValidationError = this.getIncomeValidationError();
      if (incomeValidationError) {
        this.global_utility.warning(incomeValidationError);
        this.submitted = false;
        this.searchForm.get(controlKey)?.enable();
        return;
      }

      if (
        this.preAuthorisationModel.underAdministration == 'yes' ||
        this.preAuthorisationModel.underSequestration == 'yes' ||
        this.preAuthorisationModel.underDebtReview == 'yes'
      ) {
        this.global_utility.warning(
          'Listing questions requirements are NOT valid for the application to continue!',
        );
        this.submitted = false;
        this.searchForm.get(controlKey)?.enable();
        return;
      }

      if (ControlKeyVals.employerTNR > 0) {
        this.preAuthorisationModel.employerTNR = ControlKeyVals.employerTNR;
      }
      this.preAuthorisationModel.userBranchSerial =
        this.global_utility.getGlobalData('branch_serial');
      this.preAuthorisationModel.userName = this.global_utility.getGlobalData('userDisplay');

      // Force payslips to be a proper array
      if (this.preAuthorisationModel.payslips) {
        // If it's an object with numeric keys, convert to array
        if (!Array.isArray(this.preAuthorisationModel.payslips)) {
          this.preAuthorisationModel.payslips = Object.values(this.preAuthorisationModel.payslips);
        }
        console.log('Payslips after conversion:', this.preAuthorisationModel.payslips);
        console.log('Is array now?', Array.isArray(this.preAuthorisationModel.payslips));
      }
      console.log('Payslip1?', Array.isArray(this.preAuthorisationModel.payslip1));
      console.log('Payslip2?', Array.isArray(this.preAuthorisationModel.payslip2));
      console.log('Payslip3?', Array.isArray(this.preAuthorisationModel.payslip3));

      //this.preAuthorisationModel.employer = this.quoteStoreService.PreAuthorisationModel.employer;
      window.scrollTo(0, 0);
      this.global_utility.startLoading('Submitting client information.');
      this.clientSearch.submitClientInformation(this.preAuthorisationModel).subscribe({
        next: (res: any) => {
          if (res) {
            if (res.id === 0) {
              this.global_utility.error('Saving error!! Please contact admin!');
              this.global_utility.stopLoading();
              this.global_utility.navigateToLanding();
              return;
            }

            this.quoteStoreService.PreAuthorisationModel = res;
            this.quoteStoreService.PreAuthorisationModel.quoteId = res.id;
            this.global_utility.navigateToURL(['/clientDetails', 0]);
          }
        },
        error: (err) => {
          this.global_utility.stopLoading();
          this.errorhanderService.handle(err);
        },
        complete: () => {
          this.global_utility.stopLoading();
        },
      });
    });
  }

  isSassaValid(): boolean {
    const sassaFormGroup = this.searchForm.get('sassaTypeControls');
    return sassaFormGroup?.valid || false;
  }

  isSalariedValid(): boolean {
    const salariedFormGroup = this.searchForm.get('salariedTypeControls');
    return salariedFormGroup?.valid || false;
  }

  private refreshClientTypeValidation(): void {
    setTimeout(() => {
      const activeKey = this.ClientTypeSASSA ? 'sassaTypeControls' : 'salariedTypeControls';
      const activeGroupControl = this.searchForm.get(activeKey);
      const inactiveKey =
        activeKey === 'sassaTypeControls' ? 'salariedTypeControls' : 'sassaTypeControls';
      const inactiveGroupControl = this.searchForm.get(inactiveKey);

      const activeGroup = activeGroupControl instanceof FormGroup ? activeGroupControl : null;
      const inactiveGroup = inactiveGroupControl instanceof FormGroup ? inactiveGroupControl : null;

      activeGroup?.updateValueAndValidity({ emitEvent: false });
      inactiveGroup?.updateValueAndValidity({ emitEvent: false });
      this.searchForm.updateValueAndValidity({ emitEvent: false });
    }, 0);
  }

  private ensureActiveClientTypeGroupReady(controlKey: string): boolean {
    const activeGroup = this.searchForm.get(controlKey);

    if (!(activeGroup instanceof FormGroup)) {
      this.global_utility.warning(
        'Client type details are still loading. Please wait a moment and try again.',
        'Validation pending',
      );
      return false;
    }

    return true;
  }

  private getSelectedIncomeFrequency(): string {
    return `${
      ((this.preAuthorisationModel as any)?.wageFrequency ||
        this.preAuthorisationModel?.wageCalendar) ??
      (this.preAuthorisationModel as any)?.wageFrequency ??
      this.preAuthorisationModel?.employment?.wageCalendar ??
      this.preAuthorisationModel?.employment?.wageFrequency ??
      'Monthly'
    }`.trim();
  }

  private getRelevantIncomePayslips(): any[] {
    const recordedPayslips = Array.isArray(this.preAuthorisationModel?.payslips)
      ? this.preAuthorisationModel.payslips.filter((payslip: any) => !!payslip)
      : [];

    if (recordedPayslips.some((payslip: any) => payslip?.week !== undefined)) {
      return recordedPayslips.filter((payslip: any) => payslip?.week !== undefined);
    }

    if (recordedPayslips.some((payslip: any) => payslip?.fortnight !== undefined)) {
      return recordedPayslips.filter((payslip: any) => payslip?.fortnight !== undefined);
    }

    return [
      this.preAuthorisationModel?.payslip1,
      this.preAuthorisationModel?.payslip2,
      this.preAuthorisationModel?.payslip3,
    ].filter((payslip: any) => !!payslip);
  }

  private getGrossIncomeCapForPayslip(payslip: any): number {
    if (payslip?.week !== undefined) {
      return this.grossIncomeCaps.weekly;
    }

    if (payslip?.fortnight !== undefined) {
      return this.grossIncomeCaps.fortnightly;
    }

    const normalizedFrequency = this.getSelectedIncomeFrequency().toLowerCase();
    return this.grossIncomeCaps[normalizedFrequency] ?? this.grossIncomeCaps.monthly;
  }

  private getIncomeValidationError(): string | null {
    const payslips = this.getRelevantIncomePayslips();

    for (const payslip of payslips) {
      const grossIncome = Number(payslip?.grossIncome ?? 0);
      const netIncome = Number(payslip?.nettIncome ?? 0);
      const grossIncomeCap = this.getGrossIncomeCapForPayslip(payslip);

      if (grossIncome > grossIncomeCap) {
        return 'Gross income exceeds the allowed limit';
      }

      if (grossIncome > 0 && netIncome > grossIncome) {
        return 'Net income cannot be more than Gross';
      }
    }

    return null;
  }

  onNationalitySelect(event: any) {
    const control: HTMLSelectElement = event.target as HTMLSelectElement;
    this.preAuthorisationModel.nationality = this.nationality?.value || '';

    if (event.target.value == 'OTHER') {
      control.style.borderColor = 'rgba(220,53,69, 0.8)';
      control.style.borderLeftStyle = '3px solid #a94442b4'; /* red */

      this.searchForm.controls.nationality.setErrors({ invalid: true });
      this.searchForm.controls.nationality.updateValueAndValidity();

      //alert("Only South African nationality is accepted");
      this.global_utility.info(
        'Only South African nationality is acccepted',
        'Nationality not accepted',
      );
    } else {
      control.style.borderColor = 'rgba(66, 169, 72, 0.7)';
      control.style.borderLeftStyle = '3px solid #42a948'; /* red */
    }
  }

  onLoanSelect(data: any) {
    console.log('onLoanSelect', data);
  }

  goBack() {
    this.global_utility.navigateToLanding();
  }

  openRejectOfferDialog() {
    const currQuote = this._originalPreAuthVal;
    currQuote.quoteId = this._originalPreAuthVal.id;

    this.lmsDialogHandler
      .handleRejectOfferWorkflow(
        currQuote,
        'Rejection',
        this.quoteStoreService,
        this.global_utility,
        {
          confirmRejectionLetter: true,
          printLetterFn: () => this.printFMBRejectionLetter(),
          customSuccessHandler: (res) => {
            this.isRejectOfferRejected = true;
          },
          customErrorHandler: (err) => {
            this.errorhanderService.handle(err);
          },
          loadingMessage: 'Rejecting offer...',
          navigateOnSuccess: true,
          navigationDelay: 2000,
        },
      )
      .subscribe();
  }

  // openModelSwitchDialog () {
  //   this.lmsDialogHandler
  //     .open(SwitchdataComponent, {
  //       disableClose: true,
  //       autoFocus: true,
  //       width: 'auto',
  //       height: 'auto',
  //       data: {
  //         quoteWorkBook: this.quoteStoreService.quoteWorkbook,
  //         preAuthModel: this.quoteStoreService.PreAuthorisationModel,
  //       },
  //     })
  //     .afterClosed()
  //     .subscribe((selectedModel: any) => {
  //       if (!selectedModel || selectedModel == 0) {
  //         this.global_utility.navigateToLanding();
  //         this.global_utility.error(
  //           `Quote Workbook[ID:${
  //             this.quoteStoreService.quoteWorkbook.id
  //             }] and PreAuth[ID:${
  //             this.quoteStoreService.PreAuthorisationModel.id
  //             }] mismatch. Please revert to [Client list] page and try again!!`,
  //           'DATA MISMATCH'
  //         );
  //         return;
  //       }

  //       if (selectedModel == this.quoteStoreService.quoteWorkbook.id) {
  //         this._originalPreAuthVal = this.quoteStoreService.quoteWorkbook;
  //       } else {
  //         this._originalPreAuthVal = this.quoteStoreService.PreAuthorisationModel;
  //       }

  //       this.PreAuthtoSearchDataForm();
  //       this.changesService.setTrackEnter(false);
  //       this.quoteFormLoading = false;
  //     });
  // }

  printFMBRejectionLetter() {
    this.global_utility.startLoading('Preparing FMB Rejection Letter..');
    this.quoteStoreService
      .printFMBRejectionLetter(this.preAuthorisationModel.quoteId || 0)
      .subscribe({
        next: (response) => {
          if (response) {
            this.rejectionLetterResponse = response;
            const file = new Blob([response], { type: 'application/pdf' });
            this.lmsDialogHandler.openDocumentViewer(
              URL.createObjectURL(file),
              `${this.preAuthorisationModel.quoteId}FMBRejectionLetter.pdf`,
            );
          }
        },
        error: (error) => {
          console.log('Error: ', error);
          this.global_utility.stopLoading();
        },
        complete: () => {
          this.global_utility.stopLoading();
        },
      });
  }

  onPayslipCaptured(monthpayslip: {pslip: PaySlipModel1, month: number}) {
    if (!this.preAuthorisationModel.payslips) {
      this.preAuthorisationModel.payslips = [];
    }

    console.log(
      `Capture received on Parent - payslip${monthpayslip.month} update: ${monthpayslip.pslip}`,
    );
    if (monthpayslip.pslip && monthpayslip.pslip.month === monthpayslip.month) {
      if (monthpayslip.month === 1) {
        this.preAuthorisationModel.payslip1 = monthpayslip.pslip;
      } else if (monthpayslip.month === 2) {
        this.preAuthorisationModel.payslip2 = monthpayslip.pslip;
      } else if (monthpayslip.month === 3) {
        this.preAuthorisationModel.payslip3 = monthpayslip.pslip;
      }
    }
  }

  onPayslipsUpdated(
    payslips: PaySlipModel1[]
  ) {
    // Ensure the parent model has the payslips
    this.preAuthorisationModel.payslips = payslips;
    console.log('Parent received payslips update:', payslips.length);
  }
}
